































import { Component, Vue, Prop } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import { addStatistics } from '../api'
@Component
export default class HeadVideo extends Vue {
  isPlaying: boolean = false
  @Prop() videoPoster: string
  @Prop() videoUrl: string
  @Prop() appName: string
  @Prop() activityId: any
  @Prop() id: any
  @Prop() userType: any
  video: any

  async videoPlay() {
    try {
      // 埋点-扫描海报二维码
      await addStatistics({
        activity_id: this.activityId,
        event_type: 'Click_VideoCover_xszd',
        p1: this.id,
        p2: env.type === 'ivydad' ? this.appName : 'h5',
        p3: this.userType,
      })
    } catch {}
    let video: any = this.$refs['video']
    let playFn = () => {
      let playPromise = video.play()
      if (playPromise !== undefined) {
        playPromise.catch(error => {}).then(() => {})
      }
    }
    if (!this.isPlaying) {
      playFn()
    }
    this.isPlaying = !this.isPlaying
  }
}
